module.exports = __webpack_public_path__ + "static/media/overview.8bd7d5ff.svg";